import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { License } from '@navfleet/client/license/domain/models';
import { MapConfigService, injectMapFeatureConfig } from '@navfleet/client/map/domain/data-access';
import { MAP_FEATURE_CONFIG, MapFeatureConfig, MapFeatureContribution } from '@navfleet/client/map/domain/models';
import { MAP_RESET_FEATURE_KEY, overrideMapResetConfig } from '@navfleet/client/map/reset/domain/models';
import { Observable } from 'rxjs';

export { MAP_RESET_FEATURE_KEY, overrideMapResetConfig };

/** Typed accessor for the merged feature config (defaults + container override). */
export const injectMapResetConfig = (): Observable<MapFeatureConfig> =>
    injectMapFeatureConfig<MapFeatureConfig>(MAP_RESET_FEATURE_KEY);

/**
 * Pure variant — use only when you already hold a MapConfigService reference
 * (e.g. inside another service that received it via constructor).
 */
export const getMapResetConfig = (service: MapConfigService): Observable<MapFeatureConfig> =>
    service.getFeatureConfig(MAP_RESET_FEATURE_KEY) as Observable<MapFeatureConfig>;

/** Default config contributed at app bootstrap. */
const DEFAULT_RESET: MapFeatureConfig = {
    enabled: false,
    requiredLicenses: { noneRequired: [License.Viewer] },
};

/** Multi-provider registration. Call this once in ClientShellModule (or equivalent). */
export function provideMapResetFeature(overrides: Partial<MapFeatureConfig> = {}): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: MAP_FEATURE_CONFIG,
            multi: true,
            useValue: {
                [MAP_RESET_FEATURE_KEY]: { ...DEFAULT_RESET, ...overrides },
            } satisfies MapFeatureContribution,
        },
    ]);
}
